import React, { useState } from 'react';

import dayjs from 'dayjs';
import { StarFilled } from '@ant-design/icons';
import styles from './index.module.scss';
import { WorkListReponse } from '../../../model/work_response';
import { ScheduleList, ScheduleStatus } from '../schedule/schedule';

/**
 * 競合状況ポップアップのプロパティ
 */
interface ConflictListProps {
  // 作業情報
  scheduleList: WorkListReponse;
  // エラーステータス
  status: ScheduleStatus;
  // 作業情報の表示日付
  viewDate: dayjs.Dayjs;
}

/**
 * 競合状況ポップアップ
 * @constructor
 */
export const ConflictListPage: React.FC<ConflictListProps> = ({ scheduleList, status, viewDate }) => {

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <div className={styles.box2}>
          <ScheduleList scheduleList={scheduleList} status={status} viewDate={viewDate} isConflictListMark={true}/>
        </div>
      </div>
      <div className={styles.hint}>
        <StarFilled /> ... 選択したデータ
      </div>
    </div>
  );
};
